<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import SolutoButton from '../../components/SolutoButton.vue';
import RadioButton from '../../components/RadioButton.vue';
import { mapActions, mapGetters } from 'vuex';

// this is Q15 in e-confluence page for call survey
export default defineComponent({
  name: 'SurveyQ8',
  components: {
    RadioButton,
    Button: SolutoButton
  },
  data () {
    return {
      data: [
        { text: this.$t('solved'), key: 'solved' },
        { text: this.$t('unsolved'), key: 'unsolved' }
      ]
    };
  },
  computed: {
    ...mapGetters([
      'hasBeenResolved',
      'getPickSolved',
      'isCallSurvey'
    ])
  },
  methods: {
    ...mapActions([
      'changeResolvedStatus',
      'changePickSolved'
    ]),
    change (event: string) {
      this.changePickSolved(true);
      if (event === 'solved') {
        this.changeResolvedStatus(true);
      } else {
        this.changeResolvedStatus(false);
      }
    },
    nextScreen () {
      // navigate user to Q9 which is Q16 in e-confluence page for call survey
      router.push({ path: '/survey/question9/' });
    },
    goBack () {
      router.go(-1);
    },
    checkResolved (getPickSolved: boolean, hasBeenResolved: boolean) {
      if (!getPickSolved) {
        return '';
      } else {
        if (hasBeenResolved) {
          return 'solved';
        } else {
          return 'unsolved';
        }
      }
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q1">
        <p class="with-margin">{{ isCallSurvey ? $t('survey_08_01_call') : $t('survey_08_01') }}</p>
        <radio-button :text="data" @change="change($event)" :value="checkResolved(getPickSolved, hasBeenResolved)"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :disabled="!getPickSolved"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
